angular.module('impactx.message').controller('MessageInfoListCtrl', ['$scope', '$rootScope', 'dataGen', '$route', 'ToastService', 'selectedListItems',
    'ListSelection', 'ConfirmationService', 'TranslationService', '$redirect', 'MessageService', MessageInfoListCtrl]);

function MessageInfoListCtrl($scope, $rootScope, dataGen, $route, ToastService, selectedListItems, ListSelection, ConfirmationService, TranslationService, $redirect, MessageService) {

    var ctrl = this;

    ctrl.getDetailsLink = function () {
        return "message/" + selectedListItems.getFirstSelectedId();
    };

    ctrl.canDelete = function() {
        return selectedListItems.getSelectedItems().length > 0;
    };

    ctrl.canDeleteAll = function() {
        return !selectedListItems.isAnySelected() && selectedListItems.rowCount > 0;
    };

    ctrl.delete = function () {
        deleteRequest(selectedListItems.getSelectedIds());
    };

    ctrl.deleteAll = function (event) {
        ListSelection.getAllListIds(ctrl.getMeta().params.listConfig, '/message/list/ids').then(function (listIds) {
            ConfirmationService.showConfirmationDialog(function () {
                    deleteRequest(listIds);
                }, event, TranslationService.get('deleteQuestion').replace('^0', listIds.length),
                TranslationService.get('delete'), TranslationService.get('abort'));
        });
    };

    function deleteRequest(ids) {
        var selectedItems = selectedListItems.getSelectedItems();
        dataGen.postAsForm({}, {ids: ids}, "/message/delete").then(function () {
            selectedListItems.unselectAll(selectedItems);
            $rootScope.$broadcast('list:resetPageSelection');
            MessageService.getInfoOnce();
            $route.reload();
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    };

    ctrl.canFollowMessageLink = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().route;
    };

    ctrl.followMessageLink = function() {
        var id = selectedListItems.getFirstSelectedId();
        var route = selectedListItems.getFirstSelectedItem().route;
        if (route) {
            var dataObj = {
                ids: [id]
            };
            dataGen.postAsForm({}, dataObj, '/message/markread').then(function () {
                $redirect.redirectTo(null, route);
            });
        }
    };

    ctrl.canMarkRead = function() {
        return selectedListItems.getSelectedItems().length > 0 && hasUnreadMessages();
    };

    function hasUnreadMessages() {
        return selectedListItems.getSelectedItems().some(function(item) {
            return item.unreadMessage && item.unreadMessage.value === true;
        });
    };

    ctrl.canMarkReadAll = function() {
        return !selectedListItems.isAnySelected() && selectedListItems.rowCount > 0;
    };

    ctrl.markRead = function () {
        markReadRequest(selectedListItems.getSelectedIds());
    };

    ctrl.markReadAll = function (event) {
        ListSelection.getAllListIds(ctrl.getMeta().params.listConfig, '/message/list/ids').then(function (listIds) {
            ConfirmationService.showConfirmationDialog(function () {
                    markReadRequest(listIds);
                }, event, TranslationService.get('markReadQuestion').replace('^0', listIds.length),
                TranslationService.get('markRead'), TranslationService.get('abort'));
        });
    };

    function markReadRequest(ids) {
        var selectedItems = selectedListItems.getSelectedItems();

        dataGen.postAsForm({}, {ids: ids}, "/message/markread").then(function () {
            MessageService.getInfoOnce();
            selectedListItems.unselectAll(selectedItems);
            $rootScope.$broadcast('list:resetPageSelection');
            $route.reload();
            ToastService.openStandardToast(TranslationService.get('markReadSuccess'));
        });
    }
    
    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getDetailsLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'Message'},
        {label: "edit", action: ctrl.followMessageLink, condition: ctrl.canFollowMessageLink},
        {label: "markRead", action: ctrl.markRead, condition: ctrl.canMarkRead, process: 'Message'},
        {label: "markReadAll", action: ctrl.markReadAll, condition: ctrl.canMarkReadAll, process: 'Message'},
        {label: "delete", action: ctrl.delete, condition: ctrl.canDelete, process: 'Message'},
        {label: "deleteAll", action: ctrl.deleteAll, condition: ctrl.canDeleteAll, process: 'Message'}
    ];

    ctrl.meta = {
        rowTemplate: 'modules/message/templates/messagelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/message/list/info',
        id: "messageinfolist",
        idColumn: "id",
        mainAction : {id:"new", link: "#/message/0", icon:"mdi-plus"},
        buttonDefinition: buttonDefinition,
        printEndpoint: '/message/list/excel'
    };
    ctrl.getMeta = function() {
        return this.meta;
    };
}

